import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import type { DeletionScope, DeletionScopeDetails } from '../lib/deleteUserData'

export function usePrivacyCopy() {
  const { t } = useTranslation()

  const deletionScopes = useMemo(() => {
    const scopes: Record<DeletionScope, DeletionScopeDetails> = {
      wellness_data: {
        id: 'wellness_data',
        title: t('privacy.scopes.wellness_data.title'),
        summary: t('privacy.scopes.wellness_data.summary'),
        bullets: t('privacy.scopes.wellness_data.bullets', { returnObjects: true }) as string[],
        requiresSignOut: false,
      },
      account: {
        id: 'account',
        title: t('privacy.scopes.account.title'),
        summary: t('privacy.scopes.account.summary'),
        bullets: t('privacy.scopes.account.bullets', { returnObjects: true }) as string[],
        retentionNote: t('privacy.scopes.account.retentionNote'),
        requiresSignOut: true,
      },
    }
    return scopes
  }, [t])

  return { deletionScopes, t }
}
